import client from './client';

export const getVendorsPaginated = (params) =>
  client.get('/vendors', { params }).then((r) => r.data);

export const getVendor = (uuid) =>
  client.get(`/vendors/${uuid}`).then((r) => r.data);

export const createVendor = (data) =>
  client.post('/vendors', data).then((r) => r.data);

export const updateVendor = (uuid, data) =>
  client.patch(`/vendors/${uuid}`, data).then((r) => r.data);

export const deactivateVendor = (uuid) =>
  client.delete(`/vendors/${uuid}`).then((r) => r.data);

export const activateVendor = (uuid) =>
  client.post(`/vendors/${uuid}/activate`).then((r) => r.data);

export const deleteVendor = (uuid) =>
  client.delete(`/vendors/${uuid}/permanent`).then((r) => r.data);
